<template>
    <div class="image_uploader">
        <input ref="input_upload" class="image_input" type="file" accept=".png, .jpg, .jpeg" multiple
               @change="onChange">
        <canvas class="canvas" />
        <div v-if="text !== ''" class="custom_text_props">
            {{ text }}
        </div>
        <div class="custom_delete_image">
            <span v-if="deleteMode && !readonly" class="point has-text-danger custom_text_mode">
                Mode suppression
            </span>
            <span class="point has-text-danger" @click="changeMode">
                {{ deleteMode ? 'Annuler' : 'Supprimer' }}
            </span>
            <v-icon class="has-text-danger" @click="changeMode">
                {{ deleteMode ? 'fas fa-times-circle' : 'fas fa-trash-alt' }}
            </v-icon>
        </div>
        <v-container grid-list-sm fluid class="custom_grid_image" @click="addImage" @dragover.prevent @drop="onDrop">
            <v-icon v-if="imagesData.length === 0" class="custom_upload_icon">
                fas fa-file-upload
            </v-icon>
            <v-layout row wrap>
                <v-flex v-for="(value, index) in imagesData" :key="index" class="custom_flex_image_uploaded"
                        xs6 sm3 md2 d-flex>
                    <v-card>
                        <div v-if="deleteMode" class="custom_flex_overlay" @click="deleteImageLocal(index)" />
                        <v-img :src="value" aspect-ratio="1" class="grey lighten-2">
                            <template slot="placeholder">
                                <v-layout fill-height align-center justify-center ma-0>
                                    <v-progress-circular indeterminate color="grey lighten-5" />
                                </v-layout>
                            </template>
                        </v-img>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'ImageUploader',
        props: {
            images: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            mode: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            limit: {
                type: Number,
                default: 9999
            },
            readonly: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            deleteMode: false,
            imagesId: [],
            imagesData: [],
            changeTypePost: false
        }),
        watch: {
            images: {
                deep: true,
                immediate: true,
                handler (newValue) {
                    if (this.mode === 'augment' || this.mode === 'new_augment') {
                        for (let i = 0; i < newValue.length; i++) {
                            this.imagesId.push(newValue[i]);
                            this.toDataUrl('/image/' + newValue[i], (data) => {
                                this.imagesData.push(data);
                            });
                        }
                    }
                }
            },
            readonly: function (newValue) {
                if (newValue) {
                    this.deleteMode = false;
                }
            }
        },
        methods: {
            ...mapActions('app', ['getCdn', 'postAugmentImage', 'postImage', 'postCdn',
                                  'deleteAugmentImage', 'deleteImage', 'deleteCdn']),
            changeMode: function () {
                if (!this.readonly) {
                    this.deleteMode = !this.deleteMode;
                }
            },
            onChange: function (element) {
                if (!this.readonly) {
                    let files = element.target.files;
                    if (this.imagesData.length < this.limit) {
                        this.createFiles(files);
                    } else {
                        this.$toasted.error('Limitation of ' + this.limit + ' image' + (this.limit > 1 ? 's' : ''));
                    }
                }
            },
            onDrop: function (e) {
                if (!this.readonly) {
                    e.stopPropagation();
                    e.preventDefault();
                    var files = e.dataTransfer.files;
                    if (this.imagesData.length < this.limit) {
                        this.createFiles(files);
                    } else {
                        this.$toasted.error('Limitation of ' + this.limit + ' image' + (this.limit > 1 ? 's' : ''));
                    }
                }
            },
            createFiles: function (files) {
                let _this = this;
                let dataSend = {
                    augmentationToken: this.mode === 'augment' ? this.$route.params.augmentationToken : undefined,
                    data: undefined
                };
                for (let i = 0; i < files.length; i++) {
                    dataSend.data = files[i];
                    if (_this.mode === 'augment') {
                        _this.postAugmentImage(dataSend).then((data) => {
                            _this.imagesId.push(data.msg);
                            _this.extractImage(files[i]).then(function (image) {
                                _this.imagesData.push(image);
                                _this.$emit('updateImages', _this.imagesId);
                            });
                        }).catch((err) => {
                            _this.$toasted.error(err);
                        });
                    } else if (_this.mode === 'new_augment') {
                        _this.postImage(dataSend).then((data) => {
                            _this.imagesId.push(data.msg);
                            _this.extractImage(files[i]).then(function (image) {
                                _this.imagesData.push(image);
                                _this.$emit('updateImages', _this.imagesId);
                            });
                        }).catch((err) => {
                            _this.$toasted.error(err);
                        });
                    } else {
                        if (_this.imagesId.length <= _this.limit) {
                            _this.postCdn(dataSend).then((data) => {
                                _this.imagesId.push(data.msg);
                                if (data.msg.search(this.$cdnPath) !== -1) {
                                    _this.imagesData.push(data.msg);
                                } else {
                                    _this.imagesData.push(this.$cdnPath + data.msg);
                                }
                                _this.$emit('updateImages', _this.imagesId);
                            }).catch((err) => {
                                _this.$toasted.error(err);
                            });
                        } else {
                            this.$toasted.error('Limitation of ' + _this.limit + ' image' + (_this.limit > 1 ? 's' : ''));
                        }
                    }
                }
            },
            addImage: function () {
                if (!this.deleteMode && !this.readonly) {
                    this.$el.querySelector('input').click();
                }
            },
            deleteImageLocal: function (index) {
                if (!this.readonly) {
                    let _this = this;
                    if (this.mode === 'augment') {
                        if (this.$route.params.augmentationToken) {
                            this.deleteAugmentImage(this.imagesId[index]).catch((err) => {
                                this.$toasted.error(err);
                            });
                        }
                        this.imagesId.splice(index, 1);
                        this.imagesData.splice(index, 1);
                        this.$emit('updateImages', this.imagesId);
                        let timer = setTimeout(function () {
                            if (_this.imagesId.length <= 0) {
                                _this.deleteMode = false;
                            }
                            clearTimeout(timer);
                        }, 200);
                    } else if (this.mode === 'new_augment') {
                        this.imagesId.splice(index, 1);
                        this.imagesData.splice(index, 1);
                        this.$emit('updateImages', this.imagesId);
                        let timer = setTimeout(function () {
                            if (_this.imagesId.length <= 0) {
                                _this.deleteMode = false;
                            }
                            clearTimeout(timer);
                        }, 200);
                    } else {
                        this.imagesData.splice(index, 1);
                        this.$emit('updateImages', this.imagesData);
                    }
                }
            },
            extractImage: function (file) {
                let _this = this;
                return new Promise(function (resolve) {
                    let url = URL.createObjectURL(file);
                    let img = new Image();
                    img.addEventListener('load', function () {
                        let canvas = _this.$el.querySelector('.canvas');
                        let MAX_VALUE = 640;
                        img.height = img.width > img.height
                            ? img.width > MAX_VALUE ? img.height * (MAX_VALUE / img.width) : img.height
                            : img.height > MAX_VALUE ? MAX_VALUE : img.height;
                        img.width = img.width > img.height
                            ? img.width > MAX_VALUE ? MAX_VALUE : img.width
                            : img.height > MAX_VALUE ? img.width * (MAX_VALUE / img.height) : img.width;
                        canvas.width = img.width;
                        canvas.height = img.height;
                        let ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, img.width, img.height);
                        resolve(canvas.toDataURL());
                    });
                    img.src = url;
                });
            },
            toDataUrl: (url, callback) => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        callback(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            }
        }
    };
</script>

<style lang="scss" scoped>

    .v-card {
        width: 100%;
        height: 100%;
    }

    .image_input {
        display: none;
    }

    .image_uploader {
        margin-bottom: 20px;
    }

    .canvas {
        display: none;
    }

    .custom_text_mode {
        width: 100px;
        display: inline-block;
        font-style: italic;
        font-size: 12px;
    }

    .custom_delete_image, {
        text-align: right;
        margin-top: 10px;
        right: 10px;
        position: relative;
    }

    .custom_delete_image, .custom_delete_image i, .custom_delete_image span {
        color: #FF3860;
    }

    .custom_grid_image {
        min-height: 195px;
        background-color: #e8e8e8;
        border-radius: 10px;
        padding: 5px;
        max-width: 100%;
        margin-top: 5px;
        width: 100%;
        position: relative;
    }

    .custom_flex_image_uploaded {
        padding: 10px !important;
    }

    .custom_flex_overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
        background-color: #ff3860;
        opacity: 0.3;
    }

    .custom_upload_icon {
        font-size: 40px;
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%);
    }

    .custom_text_props {
        display: inline-block;
        position: absolute;
        font-weight: bold;
        transform: translateX(14px);
    }
</style>
